{
  "user-profile-page": {
    "meta": {
      "title": "Profil",
      "description": "Profil de l'utilisateur"
    }
  }
}
